import { Callout } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import ObjectiveEmptyAttributesNotice from './ObjectiveEmptyAttributesNotice';

import type { IndexedParticipantAttribute } from '../participantAttributes';
import type { ObjectiveParticipantAttribute } from '@/types/objectives';

interface ObjectiveEmployeePickerNoticesProps {
    /** Removing the owner was refused: no one else within the reader's reach could take it. */
    isOwnerKept: boolean;
    emptyAttributes: ObjectiveParticipantAttribute[];
    attributesByKey: ReadonlyMap<string, IndexedParticipantAttribute> | undefined;
    errorMessage?: string;
}

/** What the employee picker has to say under its field: a kept owner, empty values, an error. */
export default function ObjectiveEmployeePickerNotices({
    isOwnerKept,
    emptyAttributes,
    attributesByKey,
    errorMessage,
}: ObjectiveEmployeePickerNoticesProps) {
    const { t } = useTranslation();

    return (
        <>
            {isOwnerKept && (
                <Callout
                    tone={'warning'}
                    role={'status'}
                    dataTestId={'objective-owner-kept-notice'}
                >
                    {t('objectives.form.ownerKept')}
                </Callout>
            )}

            <ObjectiveEmptyAttributesNotice
                attributes={emptyAttributes}
                attributesByKey={attributesByKey}
            />

            {errorMessage && (
                <p
                    role={'alert'}
                    className={'text-error text-[14px]'}
                >
                    {errorMessage}
                </p>
            )}
        </>
    );
}
